import { render, staticRenderFns } from "./RewardDetails.vue?vue&type=template&id=4600bcd4"
import script from "./RewardDetails.vue?vue&type=script&lang=js"
export * from "./RewardDetails.vue?vue&type=script&lang=js"
import style0 from "./RewardDetails.vue?vue&type=style&index=0&id=4600bcd4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports